module.exports = __webpack_public_path__ + "static/img/12.4d7ca56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/12.png
// module id = G04Q
// module chunks = 0